import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title } from '../../components/Shared/TitleSuccess';
import { ActionTypes } from '../../utils/enums';

const TitleComponent = props => <Title>{props.title}</Title>;

TitleComponent.propTypes = {
    title: PropTypes.string.isRequired
};

const BodyText = styled.span`
    color: #333;

    a {
        color: #ff245e;
        text-decoration: none;
    }
`;

const ElectionLinkComponent = props => (
    <BodyText>
        {props.address}.{' '}
        <a target="_blank" rel="noopener noreferrer" href={props.link}>
            Learn more
        </a>{' '}
        about elections and voting rights for your state here.
    </BodyText>
);

ElectionLinkComponent.propTypes = {
    link: PropTypes.string,
    address: PropTypes.string
};

const CheckRegistrationSuccess = props => (
    <TransitionContainerNoExit>
        {props.isRegistered ? (
            <ConfirmationCard
                rightAlign
                titleComponent={
                    <TitleComponent
                        title={`You’re all set, ${
                            props.confirmedFirstName
                        }. Our system confirms you are registered to vote at:`}
                    />
                }
                bodyComponent={
                    <ElectionLinkComponent
                        address={props.confirmedAddress}
                        link={props.specificStateInfoLink}
                    />
                }
                hideSubtitle={true}
                {...props}
            />
        ) : (
            <ConfirmationCard
                rightAlign
                titleComponent={
                    <TitleComponent title={`We cannot confirm your registration at:`} />
                }
                thankYouText={`${
                    props.unconfirmedAddress
                }. Click below to register so that you’re ready for upcoming elections. However, if you just registered within the last 4-6 weeks you may not yet be reflected in our partners records`}
                hideSubtitle={true}
                {...props}
            />
        )}
    </TransitionContainerNoExit>
);

CheckRegistrationSuccess.propTypes = {
    thankYouText: PropTypes.string,
    title: PropTypes.string,
    isRegistered: PropTypes.bool,
    specificStateInfoLink: PropTypes.string,
    confirmedFirstName: PropTypes.string,
    confirmedAddress: PropTypes.string,
    unconfirmedAddress: PropTypes.string,
    registerButtonText: PropTypes.string
};

export default connect(
    state => ({
        isRegistered: state.checkRegistration.completeCheckRegistration.isRegistered,
        registerButtonText: state.checkRegistration.registerButtonText || `REGISTER`,
        specificStateInfoLink:
            state.checkRegistration.completeCheckRegistration.specificStateInfoLink,
        confirmedFirstName: state.form.checkRegistrationForm.values.firstName,
        confirmedAddress:
            state.checkRegistration.completeCheckRegistration.confirmedAddress,
        unconfirmedAddress: `${state.form.checkRegistrationForm.values.address} ${
            state.form.checkRegistrationForm.values.homeCity
        }, ${state.form.checkRegistrationForm.values.stateId} ${
            state.form.checkRegistrationForm.values.postalCode
        }`
    }),
    {},
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.CheckRegistration)
                return true;

            return next === prev;
        }
    }
)(CheckRegistrationSuccess);
